module.exports = __webpack_public_path__ + "media/messaging-demo.d613bc22.mp4";